import type { Grupo, OrgDoPainel } from "./painel";

export type Coluna = {
  rotulo: string;
  valor: (o: OrgDoPainel) => number | null | undefined;
  /** Número maior que zero nessa coluna é problema: vermelho (perigo) ou âmbar (aviso). */
  tom?: "perigo" | "aviso";
  dinheiro?: boolean;
};

const consultas: Coluna[] = [
  { rotulo: "Consultas hoje", valor: (o) => o.clinica?.consultasHoje },
  { rotulo: "Próximos 7 dias", valor: (o) => o.clinica?.consultasSemana },
];
const doLaboratorio = (atrasados: string): Coluna[] => [
  { rotulo: "Aguardando aceite", valor: (o) => o.laboratorio?.aguardandoAceite, tom: "aviso" },
  { rotulo: "Em produção", valor: (o) => o.laboratorio?.emProducao },
  { rotulo: atrasados, valor: (o) => o.laboratorio?.atrasados, tom: "perigo" },
  { rotulo: "Em aberto", valor: (o) => o.laboratorio?.emAbertoCents, dinheiro: true },
  { rotulo: "Vencido", valor: (o) => o.laboratorio?.vencidoCents, tom: "perigo", dinheiro: true },
];

/** As colunas de cada grupo. Quem é clínica e laboratório tem as duas pontas, então os pedidos
 *  ganham o lado no nome (enviados × na produção) pra não haver dois "Atrasados". */
export const COLUNAS: Record<Grupo["chave"], Coluna[]> = {
  clinicas: [
    ...consultas,
    { rotulo: "Pedidos em aberto", valor: (o) => o.clinica?.pedidosEmAberto },
    { rotulo: "Atrasados", valor: (o) => o.clinica?.pedidosAtrasados, tom: "perigo" },
  ],
  laboratorios: doLaboratorio("Atrasados"),
  ambos: [
    ...consultas,
    { rotulo: "Enviados em aberto", valor: (o) => o.clinica?.pedidosEmAberto },
    { rotulo: "Enviados atrasados", valor: (o) => o.clinica?.pedidosAtrasados, tom: "perigo" },
    ...doLaboratorio("Atrasados na produção"),
  ],
  radiologia: [],
};
